module.exports = __webpack_public_path__ + "img/gun-turret-damage.8bcda619.png";